export default "__VITE_ASSET__DSRBRobS__"